import { defaults as StakeholderDefaults } from './StakeholderModel';
import { defaults as StakeholderLinkDefaults } from './StakeholderLinkModel';
import { defaults as ScenarioDefaults } from './ScenarioModel';
import { defaults as TagDefaults } from './TagModel';
import { defaults as RiskDefaults } from './RiskModel';
import { defaults as ConstraintDefaults } from './IndicatorModel';
import { defaults as StakeDefaults } from './StakeModel';

export const defaults = {
	Stakeholder: StakeholderDefaults,
	StakeholderLink: StakeholderLinkDefaults,
	Scenario: ScenarioDefaults,
	Tag: TagDefaults,
	Risk: RiskDefaults,
	Indicator: ConstraintDefaults,
	Stake: StakeDefaults
};
